import { render } from "./ReviewBlock.vue?vue&type=template&id=1b833da6&scoped=true"
import script from "./ReviewBlock.vue?vue&type=script&lang=js"
export * from "./ReviewBlock.vue?vue&type=script&lang=js"

import "./ReviewBlock.vue?vue&type=style&index=0&id=1b833da6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b833da6"]])

export default __exports__